
/**
 * @description
 * 로드맵 상세 > 수강 과정 > 다른 수업 리스트
 */

import { mapGetters } from 'vuex';

import CourseClassItem from './course-item/CourseClassItem.vue';

export default {
  name: 'CourseClassList',
  components: { CourseClassItem },
  computed: {
    ...mapGetters('course', ['classes']),
  },
};
